__turbopack_context__.v({
  "cardLink": "MyAccountCardGroup-module-scss-module__c7cFAW__cardLink",
  "column": "MyAccountCardGroup-module-scss-module__c7cFAW__column",
  "grid": "MyAccountCardGroup-module-scss-module__c7cFAW__grid",
  "icon": "MyAccountCardGroup-module-scss-module__c7cFAW__icon",
  "iconWrapper": "MyAccountCardGroup-module-scss-module__c7cFAW__iconWrapper",
  "imageCard": "MyAccountCardGroup-module-scss-module__c7cFAW__imageCard",
  "imageSection": "MyAccountCardGroup-module-scss-module__c7cFAW__imageSection",
  "label": "MyAccountCardGroup-module-scss-module__c7cFAW__label",
  "mdCol12": "MyAccountCardGroup-module-scss-module__c7cFAW__mdCol12",
  "mdCol3": "MyAccountCardGroup-module-scss-module__c7cFAW__mdCol3",
  "mdCol4": "MyAccountCardGroup-module-scss-module__c7cFAW__mdCol4",
  "mdCol6": "MyAccountCardGroup-module-scss-module__c7cFAW__mdCol6",
  "media": "MyAccountCardGroup-module-scss-module__c7cFAW__media",
  "mediaContainer": "MyAccountCardGroup-module-scss-module__c7cFAW__mediaContainer",
  "overlay": "MyAccountCardGroup-module-scss-module__c7cFAW__overlay",
  "wrapper": "MyAccountCardGroup-module-scss-module__c7cFAW__wrapper",
});
